import { EnvironmentTypes } from '../types';
import { getEnvironment, isCSR } from '../utils/domain';
import { getPensionHost } from '../utils/pensionProducts';
import { INTL_LOCALES } from './i18n';
export const OBS_BASE_URL = '/savingglobal/#';
export const OBS_API_BASE_URL = isCSR()
    ? `${window.location.origin}/savingglobal/rest/open_api/v2`
    : '';
export const LEGACY_LINKS = {
    DASHBOARD: `${OBS_BASE_URL}/Dashboard`,
    MY_INVESTMENTS: {
        TERM_DEPOSIT: `${OBS_BASE_URL}/MyInvestments/TermDeposit`,
        OVERNIGHT: `${OBS_BASE_URL}/MyInvestments/Overnight`,
        NOTICE: `${OBS_BASE_URL}/MyInvestments/Notice`,
        COCKPIT: `${OBS_BASE_URL}/InvestmentProducts/cockpit`,
    },
    PRODUCTS: {
        DEFAULT: `${OBS_BASE_URL}/Products`,
        EASY_ACCESS: `${OBS_BASE_URL}/Products/easyAccess`,
        OVERNIGHT: `${OBS_BASE_URL}/Products/overnight`,
        NOTICE: `${OBS_BASE_URL}/Products/notice`,
        INVESTMENT_PRODUCTS_PARENT: `${OBS_BASE_URL}/investieren`,
        INVESTMENT_PRODUCTS_ROBO: `${OBS_BASE_URL}/investieren/robo-advisor`,
        INVESTMENT_PRODUCTS_CONFIGURATOR: `${OBS_BASE_URL}/investieren/configurator`,
        INVESTMENT_PRODUCTS_CONFIGURATOR_FUNDS_OVERVIEW: `${OBS_BASE_URL}/investieren/configurator/fondsuebersicht`,
        PRIVATE_EQUITY: `${OBS_BASE_URL}/Dashboard#product-details-investmentProducts`,
        CRYPTO: `${OBS_BASE_URL}/crypto/cockpit`,
        JUSTETF_PRODUCTS: `${OBS_BASE_URL}/InvestmentProducts/justetf`,
    },
    DEPOSITS_PRODUCTS: {
        DEFAULT: `${OBS_BASE_URL}/DepositProducts`,
        ORDER: `${OBS_BASE_URL}/DepositProducts/order`,
    },
    POSTBOX: {
        INBOX: `${OBS_BASE_URL}/Postbox/inbox`,
        DOCUMENTS: `${OBS_BASE_URL}/Postbox/documents`,
        SENT: `${OBS_BASE_URL}/Postbox/sent`,
        COMPOSE: `${OBS_BASE_URL}/Postbox/Compose/new`,
    },
    SETTINGS: {
        MY_DATA: `${OBS_BASE_URL}/MyData`,
        NOTIFICATIONS: '/notifications',
        TRANSACTIONS: `${OBS_BASE_URL}/Administration/Transactions`,
        REMITTANCE: `${OBS_BASE_URL}/Administration/CustomerPayout/edit`,
        LOCK_ACCOUNT: `${OBS_BASE_URL}/BlockAccount`,
        LOCK_MTAN: `${OBS_BASE_URL}/LockMTan/edit`,
        TAX_EXEMPTION: `${OBS_BASE_URL}/TaxExemption`,
    },
    REFER_A_FRIEND: `${OBS_BASE_URL}/ReferAFriend/leads`,
    INITIAL_REFERENCE_ACCOUNT: `${OBS_BASE_URL}/InitialReferenceAccount`,
    SET_PASSWORD: `${OBS_BASE_URL}/SetPassword`,
    LOGIN: `${OBS_BASE_URL}/Login`,
    INVESTMENT_PRODUCTS: {
        SAVINGS_PLAN: `${OBS_BASE_URL}/InvestmentProducts/savingsPlan/edit`,
    },
    ABOUT: {
        PRIVACY: `${OBS_BASE_URL}/about/privacy`,
    },
    MY_DATA: {
        EDIT_PASSWORD: `${OBS_BASE_URL}/MyData/password/edit`,
        DOCUMENTS_REQUIRED: `${OBS_BASE_URL}/DocumentRequired/information/missingIdd`,
    },
    IDENTIFICATION_POA: `${OBS_BASE_URL}/Identification/proofOfAddress`,
    LOADING_SCREEN: `${OBS_BASE_URL}/Loading`,
    // PW
    REGISTER: '/register',
};
export const LINKS = {
    ADMINISTRATION: {
        USER_ACCOUNT: '/user-account',
        EXEMPTION_ORDER: '/exemption-order',
        NOTIFICATIONS: '/notifications',
        TRANSACTIONS: '/account-transactions',
        WITHDRAWAL: '/account-withdrawal',
        TRANSACTIONS_OVERDRAFT: '/account-transactions/resolve-overdraft',
    },
    DOCUMENTS: '/documents',
    POSTBOX: {
        MESSAGES: '/postbox/messages',
        NEW_MESSAGE: '/postbox/messages/?action=write-message',
    },
    USER_ACCOUNT: {
        EDIT_MOBILE_NUMBER: '/user-account/edit/mobile-number',
        EDIT_EMAIL_ADDRESS: '/user-account/edit/email-address',
        EDIT_PASSWORD: '/user-account/edit/password',
    },
    IDENTIFICATION: {
        DEFAULT: '/identification',
        UPLOAD_IDD: '/identification/upload-id-document',
        UPLOAD_POA: '/identification/upload-proof-of-address',
    },
    CUSTOMER: {
        MY_DETAILS: '/my-details',
        UPDATE_FINANCIAL_INFORMATION: 'my-details/financial-information',
        CDVC: '/my-data/validate',
        INITIAL_REFERENCE_ACCOUNT: '/my-details/initial-reference-account',
        VERIFY_IDENTITY: '/my-details/reference-account/verify-identity',
        EDIT_ADDRESS: '/my-details/edit-address',
        UPLOAD_DOCUMENTS: '/my-details/reference-account/upload-documents',
    },
    LOGIN: '/login',
    REGISTRATION: '/register',
    WELTSPAREN_DE_PENSION_LOGOUT: 'https://www.weltsparen.de/investieren/etf-ruerup/logout/',
    PRODUCTS: {
        DEFAULT: '/products',
    },
    DASHBOARD: {
        DEFAULT: '/dashboard',
        DEPOSIT_PAGES: {
            TERM: '/dashboard/savings/term',
            OVERNIGHT: '/dashboard/savings/overnight',
            NOTICE: '/dashboard/savings/notice',
        },
        VERTICAL_PAGES: {
            SAVINGS: '/dashboard/savings',
            INVESTMENTS: '/dashboard/investments',
            RETIREMENT: '/dashboard/retirement',
            ALL: '/dashboard/savings/all',
        },
        REFER_A_FRIEND: '/refer-a-friend',
        TASKS: '/dashboard/tasks',
    },
};
const getMigratedHost = () => `https://${getEnvironment() === EnvironmentTypes.PRODUCTION ? 'weltsparen' : 'staging-weltsparen'}.de/pension`;
export const PP_LINKS = {
    general: getPensionHost(),
    ruerup: `${getPensionHost()}/produkte/ruerup/`,
    fairruerup: {
        product: `${getPensionHost()}/produkte/ruerup/rechner/`,
        document: `${getPensionHost()}/assets/media/leitfaden-ruerup.pdf`,
    },
    fairriester: {
        product: `${getPensionHost()}/produkte/riester/rechner/`,
        document: `${getPensionHost()}/assets/media/leitfaden-riester.pdf`,
    },
    cockpit: `${getPensionHost()}/cockpit/`,
    postbox: `${getPensionHost()}/cockpit/kommunikation/dokumente/`,
    customerData: `${getPensionHost()}/cockpit/meine-daten/`,
    connectAccounts: `${getPensionHost()}/login/connect-accounts`,
    etfcCockpit: `${getPensionHost('invest')}/de/cockpit`,
    etfcCockpitMigrated: `${getMigratedHost()}/auth?next=/investieren/etf-configurator/cockpit/uebersicht`,
    pensionCockpitMigrated: `${getMigratedHost()}/auth?next=/investieren/etf-ruerup/cockpit`,
    cryptoMigrated: `${getMigratedHost()}/auth?next=/crypto/cockpit/uebersicht`,
};
export const INVESTMNET_LINKS = {
    COCKPITS: '/investments/wealth-management/dashboard/',
};
export const IGNORED_URLS_FOR_LOGIN_REFERER = [
    '/user-account/edit/email-address',
    '/user-account/edit/mobile-number',
    '/user-account/edit/password',
];
export const TRUSTPILOT_PROFILE_URL = {
    de: 'https://de.trustpilot.com/review/www.weltsparen.de',
    at: 'https://at.trustpilot.com/review/www.weltsparen.at',
    gb: 'https://uk.trustpilot.com/review/raisin.co.uk',
    en: 'https://www.trustpilot.com/review/www.raisin.com',
    fr: 'https://fr.trustpilot.com/review/www.raisin.fr',
    es: 'https://es.trustpilot.com/review/www.raisin.es',
    nl: 'https://nl.trustpilot.com/review/raisin.nl',
    ie: 'https://ie.trustpilot.com/review/raisin.ie',
};
export const PLATFORMS_LOGO_URLS = {
    // unauthorized state
    PUBLIC: {
        'de-DE': 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blte1a2093713009033/weltsparen-logo.svg',
        'en-GB': 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/bltb82e5f4f2a225d83/raisin-logo.svg',
        'en-IE': 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/bltb82e5f4f2a225d83/raisin-logo.svg',
        'de-AT': 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blte1a2093713009033/weltsparen-logo.svg',
        'fr-FR': 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/bltb82e5f4f2a225d83/raisin-logo.svg',
        'es-ES': 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/bltb82e5f4f2a225d83/raisin-logo.svg',
        'nl-NL': 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/bltb82e5f4f2a225d83/raisin-logo.svg',
        'pl-PL': 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/bltb82e5f4f2a225d83/raisin-logo.svg',
        'fi-FI': 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/bltb82e5f4f2a225d83/raisin-logo.svg',
    },
    // authorized state
    PRIVATE: {
        'de-DE': 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/bltb82e5f4f2a225d83/raisin-logo.svg',
        'en-GB': 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/bltb82e5f4f2a225d83/raisin-logo.svg',
        'en-IE': 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/bltb82e5f4f2a225d83/raisin-logo.svg',
        'de-AT': 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt755c7d81254bfe8d/raisin-bank-logo.svg',
        'fr-FR': 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/bltb82e5f4f2a225d83/raisin-logo.svg',
        'es-ES': 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/bltb82e5f4f2a225d83/raisin-logo.svg',
        'nl-NL': 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/bltb82e5f4f2a225d83/raisin-logo.svg',
        'pl-PL': 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/bltb82e5f4f2a225d83/raisin-logo.svg',
        'fi-FI': 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/bltb82e5f4f2a225d83/raisin-logo.svg',
    },
};
export const LEARN_MORE_LINKS_BY_LOCALES = {
    [INTL_LOCALES.COM]: 'how-it-works',
    [INTL_LOCALES.US]: 'how-it-works',
    [INTL_LOCALES.UK]: '',
    [INTL_LOCALES.GERMANY]: 'so-funktionierts',
    [INTL_LOCALES.IRELAND]: 'blog/the-relationship-gap-finance',
    [INTL_LOCALES.AUSTRIA]: '',
    [INTL_LOCALES.FRANCE]: 'comment-investir',
    [INTL_LOCALES.SPAIN]: '',
    [INTL_LOCALES.NETHERLANDS]: '',
    [INTL_LOCALES.POLAND]: 'jak-zaczac',
    [INTL_LOCALES.FINLAND]: '',
};
//# sourceMappingURL=links.js.map